import { ValueFormatterParams } from 'ag-grid-community';
import { CategoriesTreeRowItem, CategoryItemNode } from '../shared/types';
import moment from 'moment';

export const agGridDateFormatter = (params: ValueFormatterParams): string => {
    const date = params?.value;
    return moment(date).format('DD MMM YYYY');
};

export const agGridRowDataFormatter = (
    categories: CategoryItemNode[],
    treeRowData: CategoriesTreeRowItem[]
) => {
    categories.forEach((category: CategoryItemNode) => {
        if (!category.parent) {
            treeRowData.push({
                _id: category._id,
                name: category.name,
                categoriesHierarchy: [category.name],
                description: category.description,
                articleCount: category.articleCount,
                subscribersCount: category.subscribersCount ?? 0,
                views: category.views,
            });
        } else {
            const parentCategoryFromTree = treeRowData.find(
                (treeItem) => treeItem._id === category.parent
            );

            treeRowData.push({
                _id: category._id,
                name: category.name,
                categoriesHierarchy: parentCategoryFromTree
                    ? parentCategoryFromTree.categoriesHierarchy.concat(
                          category.name
                      )
                    : [category.name],
                description: category.description,
                articleCount: category.articleCount,
                subscribersCount: category.subscribersCount ?? 0,
                views: category.views,
            });
        }

        if (category.children.length) {
            agGridRowDataFormatter(category.children, treeRowData);
        }
    });
};

export interface Sorting {
    field: string;
    direction?: 'asc' | 'desc';
}
